import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Keepalive } from '@ng-idle/keepalive';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';
import { AuthService } from './services/auth.service';
// import { User } from './shared/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
// import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnDestroy, OnInit {
  private subscription: Subscription;
  public userLoggedIn: boolean;
  public isShowMenu: boolean;
  // public monitorDisengage: boolean;

  title = 'artemisaweb';
  idleState = 'NOT_STARTED';
  timedOut = false;
  lastPing?: Date = null;
  progressBarPopup: NgbModalRef;

  constructor(
    private element: ElementRef,
    private idle: Idle,
    private keepalive: Keepalive,
    private ngbModal: NgbModal,
    private authService: AuthService,
    private spinnerService: NgxSpinnerService
  ) {
    // console.log('constructor AppComponent...');

    // sets an idle timeout of 15 minutes (900).
    idle.setIdle(300);
    // sets a timeout period of 5 minutes (300).
    idle.setTimeout(60);
    // sets the interrupts like Keydown, scroll, mouse wheel, mouse down, and etc
    idle.setInterrupts([
      new EventTargetInterruptSource(
        this.element.nativeElement,
        'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll'
      )
    ]);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'NO_LONGER_IDLE';
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'TIMED_OUT';
      this.timedOut = true;
      this.closeProgressForm();
    });

    idle.onIdleStart.subscribe(() => {
      (this.idleState = 'IDLE_START'), this.openProgressForm(1);
    });

    idle.onTimeoutWarning.subscribe((countdown: any) => {
      this.idleState = 'IDLE_TIME_IN_PROGRESS';
      this.progressBarPopup.componentInstance.count = Math.floor((countdown - 1) / 60) + 1;
      this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
      this.progressBarPopup.componentInstance.countMinutes = Math.floor(countdown / 60);
      this.progressBarPopup.componentInstance.countSeconds = countdown % 60;
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(5);
    /**
     *  // Keepalive can ping request to an HTTP location to keep server session alive
     * keepalive.request('<String URL>' or HTTP Request);
     * // Keepalive ping response can be read using below option
     * keepalive.onPing.subscribe(response => {
     * // Redirect user to logout screen stating session is timeout out if if response.status != 200
     * });
     */
    this.reset();
  }

  ngOnInit() {
    this.isShowMenu = true;
    this.userLoggedIn = this.authService.isLoggedIn();
    console.log('ngOnInit I Logged in value: ' + this.userLoggedIn);

    this.subscription = this.authService.getObservableLoggedIn().subscribe(value => {
      this.userLoggedIn = value;
      console.log('ngOnInit II change login value event: ' + value);
    });
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  ngOnDestroy() {
    this.resetTimeOut();
  }

  reverseNumber(countdown: number) {
    return 300 - (countdown - 1);
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;

    // const tmpUserData = localStorage.getItem('loginUserData');
    // const loginUserData = (tmpUserData) ? JSON.parse(tmpUserData) as User : null;
    // console.log('ProgressbarComponent: logout: loginUserData: ', JSON.stringify(loginUserData));
    // this.authService.logoutUser(loginUserData);
    // this.logout();
  }

  openProgressForm(count: number) {
    this.progressBarPopup = this.ngbModal.open(ProgressbarComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true
    });
    this.progressBarPopup.componentInstance.count = count;
    this.progressBarPopup.result.then((result: any) => {
      console.log('openProgressForm: result: ', result);
      if ((result !== '' && 'logout' === result) || typeof result === 'undefined') {
        this.logout();
      } else {
        this.reset();
      }
    });
  }

  logout() {
    this.resetTimeOut();
    this.authService.logoutUser();
  }

  closeProgressForm() {
    this.progressBarPopup.close();
  }

  resetTimeOut() {
    this.idle.stop();
    this.idle.onIdleStart.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
  }

  onDisengage(event: boolean) {
    console.log('onDisengage: event: ', event);
    // this.isShowMenu = event;
  }
}
